/**
 * bestSellerCard
 */
class bestSellerCard extends HTMLElement {
    constructor() {
        super();
        this.bestSellerCard();
    }

    /**
     * Initialize the bestSellerCard component
     */
    bestSellerCard() {
        this.addEventListener('click', (event) => {
            // Check if the clicked element is an <a> tag
            const anchorTag = event.target.closest('a');
            if (anchorTag) {
                return;
            }
            // Toggle the 'active' class
            const bestSellerBlock = event.target.closest('.best-seller-block');
            if (bestSellerBlock) {
                if (bestSellerBlock.classList.contains('active')) {
                    bestSellerBlock.classList.remove('active');
                } else {
                    bestSellerBlock.classList.add('active');
                }
            }
        });
    }
}

customElements.define("custom-best-seller-card", bestSellerCard);